import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#0a0f1e] text-white pt-10 pb-20 overflow-hidden" data-id="element-74">
      {/* Background dot grid */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#00d4ff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-75"></div>
      {/* Radial glow center */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-76"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-77">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-78">
          <img src="https://cdn.magicpatterns.com/uploads/pXbuNZGxSWyNBapdC5JMpM/Cuerpo-4.0-Logo.png" alt="Plan B: Cuerpo 4.0" className="h-16 md:h-20 object-contain drop-shadow-lg" data-id="element-79" />
        </div>

        {/* Pre-headline badge */}
        <div className="text-center mb-6" data-id="element-80">
          <span className="inline-block px-4 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/40 text-cyan-400 text-sm font-semibold tracking-widest uppercase" data-id="element-81">
            Para Hombres y Mujeres de 40+
          </span>
        </div>

        {/* Main Headline — Oswald font */}
        <h1 className="font-heading text-5xl md:text-7xl font-bold text-center leading-tight mb-4 tracking-tight uppercase" data-id="element-82">
          ¿Por qué tu metabolismo se{' '}
          <span className="text-[#00d4ff]" data-id="element-83">'jubiló'</span> a los 40?
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-slate-300 text-center mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-84">
          (Y el <span className="text-white font-bold" data-id="element-85">Plan B</span> para
          despertarlo tras una década dormido — sin dietas extremas ni gimnasio
          diario).
        </p>

        {/* Product Mockup Image */}
        <div className="relative mx-auto max-w-md mb-12" data-id="element-86">
          <div className="absolute inset-0 bg-cyan-500 blur-3xl opacity-20 rounded-full scale-75" data-id="element-87"></div>
          <img src="https://cdn.magicpatterns.com/uploads/pXbuNZGxSWyNBapdC5JMpM/Cuerpo-4.0-Logo.png" alt="Plan B: Cuerpo 4.0 — Programa Digital" className="relative z-10 w-full drop-shadow-2xl rounded-2xl" data-id="element-88" />
        </div>

        {/* Opening Lead */}
        <div className="bg-[#0d1529] border border-cyan-500/20 p-8 md:p-10 rounded-2xl shadow-2xl max-w-3xl mx-auto border-l-4 border-l-[#00d4ff]" data-id="element-89">
          <p className="text-lg md:text-xl font-medium mb-5 italic text-slate-300" data-id="element-90">
            "¿Te ha pasado? Te miras al espejo y no reconoces esa zona
            abdominal."
          </p>
          <p className="text-lg leading-relaxed mb-4 text-slate-200" data-id="element-91">
            No importa si comes una ensalada o si te matas en la caminadora: la
            báscula no se mueve. Peor aún, a las 3 de la tarde tu energía cae en
            picada y solo piensas en el próximo café.
          </p>
          <p className="text-lg leading-relaxed font-semibold text-white" data-id="element-92">
            No estás envejeciendo mal. No es falta de voluntad. Es que estás
            tratando de manejar un cuerpo de 40 años con las reglas de uno de
            20. Y eso, matemáticamente, no funciona.
          </p>
        </div>

        {/* CTA */}
        <div className="mt-12 text-center" data-id="element-93">
          <a href="#oferta-heading" className="cta-pulse inline-block bg-[#00d4ff] hover:bg-[#0099cc] text-[#0a0f1e] font-heading font-bold text-xl md:text-2xl uppercase tracking-wider px-10 py-5 rounded-xl transition-colors duration-200" data-id="element-94">
            QUIERO MI PLAN B AHORA →
          </a>
          <p className="mt-4 text-slate-400 text-sm" data-id="element-95">
            ⚡ Precio de lanzamiento — Solo por tiempo limitado
          </p>
        </div>

        <div className="mt-12 text-center" data-id="element-96">
          <ArrowDownIcon className="w-8 h-8 text-cyan-400 mx-auto animate-bounce" data-id="element-97" />
        </div>
      </div>
    </section>;
}